import React from 'react';
import styled from 'styled-components';
import Login from '../components/Login';
import logo from './logo.png';

const LoginPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  background-color: #f5f5f5;
`;

const Logo = styled.img`
  height: 80px;
  margin-bottom: 30px;
`;

const LoginCard = styled.div`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 30px;
  width: 100%;
  max-width: 400px;
`;

const LoginPage = ({ onLogin }) => {
  return (
    <LoginPageContainer>
      <Logo src={logo} alt="Sirdata Logo" />
      <LoginCard>
        <Login onLogin={onLogin} />
      </LoginCard>
    </LoginPageContainer>
  );
};

export default LoginPage;
